import { createClient } from "@supabase/supabase-js"
import { SUPABASE_URL, SUPABASE_KEY } from "./environmentVariables"
import { Database } from "./types/supabase"

export const supabase = createClient<Database>(SUPABASE_URL as string, SUPABASE_KEY as string)
